import dayjs from 'dayjs'

export function getDateDifference(
  date1: string,
  date2: string,
  format: 'day' | 'month' | 'hour' = 'day',
): number {
  return dayjs(date1).startOf(format).diff(dayjs(date2).startOf(format), format)
}
